module.exports = __webpack_public_path__ + "static/img/pice2.5d61e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/pice2.png
// module id = go+o
// module chunks = 0